import "./ProfileButtonTemplate.scss"
import React from 'react'
import { useScreenSize } from '../../../hook/useScreenSize';

const Avatar: React.FC<{ profilePicture?: string }> = ({ profilePicture }) => (
    <div className="button-img-container">
        {profilePicture
            ? <img className="button-img" src={profilePicture} alt="employee" />
            : <i className='button-img dx-icon-user' />}
    </div>
);

const ButtonDescription: React.FC<{ text: string; description: string, showDescription: boolean }> = ({
    text, description, showDescription
}) => (
    <div className="text-container">
        <div className="button-title">{text}</div>
        { showDescription &&
            <div className="button-row">{description}</div>
        }
    </div>
);

interface ProfileButtonTemplateProps {
    text: string
    profilePicture?: string
    description?: string
}

export const ProfileButtonTemplate: React.FC<ProfileButtonTemplateProps> = (props) => {
    const { isSmall } = useScreenSize()

    return (
        <>
            <Avatar profilePicture={props.profilePicture} />
            <ButtonDescription text={props.text} description={props.description || ''} showDescription={!isSmall} />
        </>
    )
}
